import { toCamelCase } from '../to-camel-case';
export var COMPONENT_METADATA_KEY = '__awsuiMetadata__';
export default function attachMetadataToNode(domNode) {
    var formattedComponentName = toCamelCase(domNode.component.__componentName).replace(/^Awsui/, '');
    domNode[COMPONENT_METADATA_KEY] = {
        name: formattedComponentName,
        version: domNode.component.__componentVersion
    };
}
//# sourceMappingURL=index.js.map